export enum WalletTypes {
  Metamask = 'metamask',
  WalletConnect = 'walletConnect',
}
